module.exports = __webpack_public_path__ + "img/light-Path 16 Copy 2@3x.37d511b7.png";